export function getStartOfWeek(date: Date, startOfWeek: number = 1): Date {
  const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
  const diff = (day < startOfWeek ? 7 : 0) + day - startOfWeek;
  const startDate = new Date(date);
  startDate.setDate(date.getDate() - diff);
  startDate.setHours(0, 0, 0, 0); // Reset time to midnight
  return startDate;
}

export function addDays(date: Date = new Date(), days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function isSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

export function isBeforeDay(baseDate: Date, date2: Date): boolean {
  return (
    baseDate.getFullYear() > date2.getFullYear() ||
    (baseDate.getFullYear() === date2.getFullYear() && baseDate.getMonth() > date2.getMonth()) ||
    (baseDate.getFullYear() === date2.getFullYear() && baseDate.getMonth() === date2.getMonth() && baseDate.getDate() >= date2.getDate())
  );
}

export function isAfterDay(baseDate: Date, date2: Date): boolean {
  return (
    baseDate.getFullYear() < date2.getFullYear() ||
    (baseDate.getFullYear() === date2.getFullYear() && baseDate.getMonth() < date2.getMonth()) ||
    (baseDate.getFullYear() === date2.getFullYear() && baseDate.getMonth() === date2.getMonth() && baseDate.getDate() <= date2.getDate())
  );
}

export function changeDateKeepTime(originalDate: Date, newDate: Date): Date {
  const updatedDate = new Date(newDate);
  updatedDate.setHours(originalDate.getHours());
  updatedDate.setMinutes(originalDate.getMinutes());
  updatedDate.setSeconds(originalDate.getSeconds());
  updatedDate.setMilliseconds(originalDate.getMilliseconds());
  return updatedDate;
}

export function setToStartOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

export function setToEndOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

export function setToStartOfNextDay(date: Date): Date {
  return setToStartOfDay(addDays(date, 1));
}

export function differenceInDays(date1: Date, date2: Date): number {
  const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

  const diffTime = d2.getTime() - d1.getTime();
  return Math.round(diffTime / (1000 * 60 * 60 * 24)); // Konwersja milisekund na dni
}